import { render, staticRenderFns } from "./ListAppEnqB2b.vue?vue&type=template&id=4f5efb55&"
import script from "./ListAppEnqB2b.vue?vue&type=script&lang=js&"
export * from "./ListAppEnqB2b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports